import { useTranslation } from "react-i18next";
import { FaMinus, FaPlus } from "react-icons/fa6";
import { CategoryInfoListType } from "../types/category_info_type";
import {
  WORKHOUR_SHORT,
  WORKHOUR_MEDIUM,
  WORKHOUR_LONG,
  NO_SELECTION,
  CATEGORY,
  WORK_HOUR,
} from "../../../../constants/common_constants";

interface InfarenceFactorFilterProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  filterItem: string;
  filterCriteria: string | number;
  setFilterItem: React.Dispatch<React.SetStateAction<string>>;
  setFilterCriteria: React.Dispatch<React.SetStateAction<string | number>>;
  categoryInfoList: CategoryInfoListType;
  setCategoryInfoList: React.Dispatch<
    React.SetStateAction<CategoryInfoListType>
  >;
  applyFilter: () => void;
}

export const InferenceFactorFilter: React.FC<InfarenceFactorFilterProps> = ({
  open,
  setOpen,
  filterItem,
  filterCriteria,
  setFilterItem,
  setFilterCriteria,
  categoryInfoList,
  applyFilter,
}) => {
  // 言語切り替え用
  const { t } = useTranslation();

  // // フィルター項目が変化したときの処理
  const handleSelectFilterItem = (filterItem: string) => {
    setFilterItem(filterItem);
    if (filterItem === NO_SELECTION) {
      setFilterCriteria(NO_SELECTION);
    } else {
      if (filterItem === CATEGORY) {
        setFilterCriteria(categoryInfoList.category[0].categoryId);
      } else {
        setFilterCriteria(1);
      }
    }
  };

  // // フィルター条件が変化したときの処理
  const handleSelectFilterCriteria = (filterCriteria: string | number) => {
    setFilterCriteria(filterCriteria);
  };

  // フィルターメニュー一層目
  const renderDisplaySetting = () => {
    return (
      <div
        onClick={() => setOpen((prevState) => !prevState)}
        className="flex items-center bg-white border border-gray-500 py-2 cursor-pointer"
      >
        <div className="px-3 cursor-pointer">
          {open ? <FaMinus /> : <FaPlus />}
        </div>
        <p>{t("推定要因項目画面.確率順")}</p>
      </div>
    );
  };
  // フィルターメニュー二層目
  const renderFilterMenu = () => {
    return (
      <div className="border border-t-0 border-gray-500 bg-white shadow-md">
        <div className="pl-[18px] pr-[18px]">
          <div className="flex flex-col">
            <p className="text-nowrap">
              {t("推定要因項目画面.フィルター項目")}：
            </p>
            {/* フィルター項目 */}
            <select
              className="grow border border-sub-blue rounded bg-white text-black ml-1 min-w-0 p-1 h-7"
              value={filterItem}
              onChange={(e) => handleSelectFilterItem(e.target.value)}
            >
              <option value={NO_SELECTION}>
                {t("推定要因項目画面.全数")}
              </option>
              <option value={CATEGORY}>{t("推定要因項目画面.カテゴリ別")}</option>
              <option value={WORK_HOUR}>{t("推定要因項目画面.工数別")}</option>
            </select>
          </div>
          <div className="flex flex-col mb-3">
            <p className="text-nowrap">
              {t("推定要因項目画面.フィルター条件")}：
            </p>
            {/* フィルター条件 */}
            <select
              className={`grow border border-sub-blue rounded ${
                !(filterItem === NO_SELECTION || filterItem === "")
                  ? "bg-white"
                  : "pointer-events-none bg-gray-500"
              } text-black ml-1 min-w-0 p-1 h-7`}
              value={filterCriteria}
              onChange={(e) =>
                handleSelectFilterCriteria(
                  filterItem === CATEGORY
                    ? e.target.value
                    : Number(e.target.value),
                )
              }
            >
              {(filterItem === NO_SELECTION || filterItem === "") && (
                <option value={NO_SELECTION}></option>
              )}
              {filterItem === CATEGORY ? (
                categoryInfoList.category.map((category) => (
                  <>
                    <option value={category.categoryId} key={category.label}>
                      {category.label}
                    </option>
                  </>
                ))
              ) : (
                <>
                  <option value={WORKHOUR_SHORT}>
                    {t("推定要因項目画面.小")}
                  </option>
                  <option value={WORKHOUR_MEDIUM}>
                    {t("推定要因項目画面.中")}
                  </option>
                  <option value={WORKHOUR_LONG}>
                    {t("推定要因項目画面.大")}
                  </option>
                </>
              )}
            </select>
          </div>
        </div>
        {/* 適用ボタン */}
        <div className="flex justify-center mb-4">
          <button
            className="border border-2 rounded-full border-main-red px-2 py-1 min-w-20 w-40"
            onClick={applyFilter}
          >
            {t("推定要因項目画面.適用")}
          </button>
        </div>
      </div>
    );
  };
  // フィルターメニュー全体
  const renderMenu = () => {
    return (
      <>
        {/* 一層目 */}
        {renderDisplaySetting()}
        {/* 二層目 */}
        {open && renderFilterMenu()}
      </>
    );
  };

  return <div className="w-[62vw]">{renderMenu()}</div>;
};
